export const ICON_TYPES = {
  LIKE_ICON:
    'https://user-images.githubusercontent.com/79133602/173191749-0e7f1a03-ed89-4f06-8e83-ffc273086997.svg',
  SEARCH_GRAY:
    'https://user-images.githubusercontent.com/81489300/173283098-e85cc9c6-4346-48a4-bec8-c4eacfbc0b1f.svg',
  ADD_POST:
    'https://user-images.githubusercontent.com/81489300/173678716-e2048fff-d488-4208-af32-688b279bcaf3.svg',
  ADD_POST_ACTIVE:
    'https://user-images.githubusercontent.com/81489300/173678717-e9131e2b-55ed-49e4-b783-309cbe203633.svg',
  MY_PAGE:
    'https://user-images.githubusercontent.com/81489300/173678705-d0a9ec75-b111-4885-9950-3eddb9dcf7b6.svg',
  MY_PAGE_ACTIVE:
    'https://user-images.githubusercontent.com/81489300/173678708-1fdc444c-b74e-4959-8bb3-172326e0cc53.svg',
  SEARCH:
    'https://user-images.githubusercontent.com/81489300/173678712-b4a21a03-841b-4712-b42c-757a3058d7c8.svg',
  SEARCH_ACTIVE:
    'https://user-images.githubusercontent.com/81489300/173678715-706dac90-de5f-4afc-8c36-22087e93ff5b.svg',
  HOME: 'https://user-images.githubusercontent.com/81489300/173678719-27aa0c89-30af-4b7a-9d6d-76848432dfe4.svg',
  HOME_ACTIVE:
    'https://user-images.githubusercontent.com/81489300/173678699-a64a29f5-755c-42b0-b7aa-6a074362f4c2.svg',
  NOTIFICATION:
    'https://user-images.githubusercontent.com/81489300/173201548-ccbf5ac3-9093-479d-bc88-f2cdafe4e05f.svg',
  ARROW_LEFT:
    'https://user-images.githubusercontent.com/81489300/173201549-47a7d6cb-1864-477b-8ca5-296450b39976.svg',
  MY_INFO:
    'https://user-images.githubusercontent.com/81489300/173201550-4f2e0d56-ad31-4dcc-b8fd-b6e12d21fce2.svg',
  TAG_DELETE:
    'https://user-images.githubusercontent.com/81489300/173329512-2b867ca3-9829-4bed-8209-78842fc39aba.svg',
  COMMENT:
    'https://user-images.githubusercontent.com/81489300/173429404-8d397092-7272-4283-9ffc-367ee0639014.svg',
  EDIT: 'https://user-images.githubusercontent.com/81489300/173429407-3d9820b0-dc38-4a88-bec5-cb4bb2c1d513.svg',
  LOGOUT:
    'https://user-images.githubusercontent.com/81489300/173429408-ec26bec0-0105-4b45-b426-3e9bd85cef11.svg',
  KEY: 'https://user-images.githubusercontent.com/81489300/173429409-184607e1-7e98-455b-ba3f-6fe3230652b4.svg',
  GRID: 'https://user-images.githubusercontent.com/81489300/173429411-3f8f12aa-596f-494d-92bc-7aba68e78c27.svg',
  GRID_INACTIVE:
    'https://user-images.githubusercontent.com/81489300/174833898-8792cdc8-4f2d-4ff0-867f-6798ce6437c1.svg',
  GRID_ACTIVE:
    'https://user-images.githubusercontent.com/81489300/173429411-3f8f12aa-596f-494d-92bc-7aba68e78c27.svg',
  HEART:
    'https://user-images.githubusercontent.com/81489300/173429417-c333f19d-eace-4675-973d-bd4307fd5938.svg',
  HEART_RED:
    'https://user-images.githubusercontent.com/81489300/173429412-1517ad44-2524-40e4-aca9-f8ff330e785c.svg',
  HEART_ACTIVE:
    'https://user-images.githubusercontent.com/81489300/173429417-c333f19d-eace-4675-973d-bd4307fd5938.svg',
  HEART_INACTIVE:
    'https://user-images.githubusercontent.com/81489300/174833902-c53ede04-f875-4158-b040-a595591cde24.svg',
  MORE: 'https://user-images.githubusercontent.com/81489300/173678702-f33d6b86-fc17-4d08-8d3f-fc11d7abd791.svg',
  CLOSE:
    'https://user-images.githubusercontent.com/81489300/174680711-d171d380-f02c-4afe-8d60-7f5ef2d9d821.svg',
};
